import { tryCatchHelper } from '../../../helpers';
import { ACTIVO_RONDAS, ALL_RONDAS, LOADING_ALL_RONDAS } from './RondasReducer';
import {
  deleteRondasService,
  allRondasService,
  oneRondasService,
  saveRondasService,
} from './RondasService';

export const allRondasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_RONDAS, payload: true });
    const res = await allRondasService(params);
    dispatch({ type: ALL_RONDAS, payload: res.data });
    dispatch({ type: LOADING_ALL_RONDAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_RONDAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveRondasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveRondasService(id, data);
    notify(res.data.message);
    await allRondasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoRondasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_RONDAS, payload: data });
};

export const oneRondasAction = async (dispatch, id) => {
  try {
    const res = await oneRondasService(id);
    await setActivoRondasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteRondasAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteRondasService(id);
    notify(res.data.message);
    await setActivoRondasAction(dispatch, null);
    await allRondasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
